import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompetitionsRoutingModule } from './competitions-routing.module';
import { BootstrapCompetitionsComponent } from './bootstrap-competitions/bootstrap-competitions.component';
import { CompetitionInfoComponent } from './competition-info/competition-info.component';
import { CompetitionPodiumComponent } from './common-competitions-components/competition-podium/competition-podium.component';
import { CompetitionPodiumViewComponent } from './common-competitions-components/competition-podium-view/competition-podium-view.component';
import { CompetitionInitService } from './services/competition-init.service';
import { CoreModule } from '../library/core.module';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { CompetitionDocumentsModule } from './competition-documents/competition-documents.module';


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [CompetitionInfoComponent, BootstrapCompetitionsComponent],
  imports: [
    CommonModule,
    CompetitionsRoutingModule,
    CoreModule,
    CommonPageComponentsModule
  ],
  providers: [CompetitionInitService]
})
export class CompetitionsModule { }
